import AdminsDatatableContainer from "@/Admins/AdminsDatatableContainer.vue";
import CommunicationsManagerContainer from "@/Communications/CommunicationsManagerContainer.vue";
import CompanyCoverageAreasContainer from "@/CompanyCoverageAreas/CompanyCoverageAreasContainer.vue";
import CompanySettingsContainer from "@/CompanySettings/CompanySettingsContainer.vue";
import CompanyVehiclesContainer from "@/CompanyVehicles/CompanyVehiclesContainer.vue";
import CustomizationsPageContainer from "@/Customizations/CustomizationsPageContainer.vue";
import EquipmentSetupPage from "@/EquipmentSetup/EquipmentSetupPage.vue";
import FinancingIndexContainer from "@/Financing/FinancingIndexContainer.vue";
import Marketplace from "@/Marketplace/Marketplace.vue";
import Programs from "@/Programs/Programs.vue";
import TimeCardsReportIndex from "@/Timesheets/TimeCardsReportIndex.vue";

export default [
  {
    path: "/company/settings",
    name: "CompanySettingsContainer",
    component: CompanySettingsContainer,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/communications",
    name: "CommunicationsManagerContainer",
    component: CommunicationsManagerContainer,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/marketplace",
    name: "Marketplace",
    component: Marketplace,
    meta: {
      permissionRoles: ["integrations"]
    }
  },
  {
    path: "/customizations/edit",
    name: "CustomizationsPageContainer",
    component: CustomizationsPageContainer,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/programs",
    name: "Programs",
    component: Programs,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/financing",
    name: "FinancingIndexContainer",
    component: FinancingIndexContainer,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/equipment_setup",
    name: "EquipmentSetupPage",
    component: EquipmentSetupPage,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/vehicles",
    name: "CompanyVehiclesContainer",
    component: CompanyVehiclesContainer,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/coverage_areas",
    name: "CompanyCoverageAreasContainer",
    component: CompanyCoverageAreasContainer,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/admins",
    name: "AdminsDatatableContainer",
    component: AdminsDatatableContainer,
    meta: {
      permissionRoles: ["user_settings"]
    }
  },
  {
    path: "/company/timesheets/time_cards",
    name: "CompanyTimeCardsReportIndex",
    component: TimeCardsReportIndex,
    meta: {
      permissionRoles: ["timecards"]
    }
  }
];
